export interface ScriptGetAllParams {
    is_active?: boolean;
}
